import { render, staticRenderFns } from "./addbanji.vue?vue&type=template&id=87b411e2&scoped=true&"
import script from "./addbanji.js?vue&type=script&lang=js&"
export * from "./addbanji.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b411e2",
  null
  
)

export default component.exports